import * as Worker from "./worker";

// eslint-disable-next-line import/no-webpack-loader-syntax
import createWorker from "workerize-loader!./worker";

const sampleWorker = createWorker<typeof Worker>();

export const useWorker = () => sampleWorker;
